/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";

import hero1 from "./assets/hero1.jpg";
import hero2 from "./assets/hero2.jpg";
import hero3 from "./assets/hero3.jpg";
import Layout from "../../components/Layout";
import Header from "../../components/Header";
import ProgressDots from "../../components/ProgressDots";
import HeroImage, { HeroPhoto } from "../../components/HeroImage";
import { PrimaryCTALink } from "../../components/PrimaryCTA";
import CheckList from "../../components/CheckList";
import Cookies from "js-cookie";

export function SignupPage1() {
    let TUTOR_REFERRAL_CODE_ID = "trc";
    let REFERRAL_CODE_ID = "rc";

    let urlPathParams = new URLSearchParams(window.location.search);
    let referralCode = urlPathParams.get(REFERRAL_CODE_ID);

    if (referralCode) {
        Cookies.set(TUTOR_REFERRAL_CODE_ID, referralCode);
    }

    return (
        <>
            <Header>
                <ProgressDots numberOfDots={3} highlightedDotIndex={0} />
            </Header>
            <Layout spacing={40}>
                <HeroPhoto src={hero1} alt="Happy students" />
                <div>
                    <h2>The best student job in town</h2>
                    <p>
                        Having a student job doesn't have to mean pouring pints.
                        With MyTutor you can earn good money, set your own
                        hours, and make a difference.
                    </p>
                </div>
                <PrimaryCTALink to="/signup/2">Continue</PrimaryCTALink>
            </Layout>
        </>
    );
}

export const SignupPage2 = () => (
    <>
        <Header>
            <ProgressDots numberOfDots={3} highlightedDotIndex={1} />
        </Header>
        <Layout spacing={40}>
            <HeroImage src={hero2} alt="Live streaming lesson with laptop" />
            <div>
                <h2>Work from anywhere in the UK</h2>
                <p>
                    All tutorials take place in our online lesson space. This
                    means you can work remotely, wherever you are in the UK.
                </p>
                <p>
                    All you need is a laptop, earphones, and a stable internet
                    connection.
                </p>
            </div>
            <PrimaryCTALink to="/signup/3">Continue</PrimaryCTALink>
        </Layout>
    </>
);

export const SignupPage3 = () => (
    <>
        <Header>
            <ProgressDots numberOfDots={3} highlightedDotIndex={2} />
        </Header>
        <Layout spacing={40}>
            <HeroImage
                src={hero3}
                alt="Illustration of tutors standing in a line"
            />
            <div>
                <h2>No previous experience required</h2>
                <p>
                    Most of our tutors had never tutored before starting with
                    us. You just need to be someone who:
                </p>
                <CheckList
                    doneItems={[
                        "Enjoys working with people",
                        "Loves their subject",
                        "Is looking for a flexible job",
                    ]}
                />
            </div>
            <PrimaryCTALink to="/signup/form">Let’s go!</PrimaryCTALink>
        </Layout>
    </>
);
